import React from 'react';

const MetadataCard = ({ metadata = {}, onChange, setMetadata }) => {
    const handleChange = (e) => {
        const { name, value } = e.target;
        const updated = {
            ...metadata,
            [name]: value
        };
        if (onChange) {
            onChange(updated);
        } else if (setMetadata) {
            setMetadata(prev => ({
                ...prev,
                [name]: value
            }));
        }
    };

    if (!metadata) return null;

    return (
        <div className="bank-statement-card mb-3">
            <div className="metadata-row">
                <div className="metadata-field">
                    <label>BANK NAME</label>
                    <input 
                        type="text" 
                        name="bankName" 
                        value={metadata.bankName || ''} 
                        onChange={handleChange} 
                        placeholder="SAMPLE TEST BANK"
                    />
                </div>
                <div className="metadata-field">
                    <label>ACCOUNT DETAILS</label>
                    <input 
                        type="text" 
                        name="accountDetails" 
                        value={metadata.accountDetails || ''} 
                        onChange={handleChange} 
                        placeholder="Checking Account (...1234)"
                    />
                </div>
                <div className="metadata-field">
                    <label>STATEMENT PERIOD</label>
                    <input 
                        type="text" 
                        name="statementPeriod" 
                        value={metadata.statementPeriod || ''} 
                        onChange={handleChange} 
                        placeholder="June 01, 2026 - June 30, 2026"
                    />
                </div>
            </div>
        </div>
    );
};

export default MetadataCard;